import { Box, Radio, useTheme } from "@mui/material";
import { RadioProps } from "@mui/material/Radio/Radio";
import { SenecFPPTheme } from "src/styles/fpp-theme/theme.types";

const CheckedRadio = () => {
    const theme: SenecFPPTheme = useTheme();

    return (
        <Box width={20} height={20} borderRadius={3} alignContent={"center"} sx={{ bgcolor: theme.palette.primary.main }}>
            <Box width={12} height={12} borderRadius={6} m={"auto"} sx={{ bgcolor: theme.palette.white.main }} />
        </Box>
    );
};

const UncheckedRadio = () => {
    const theme: SenecFPPTheme = useTheme();

    return (
        <Box
            width={20}
            height={20}
            borderRadius={3}
            alignContent={"center"}
            sx={{
                bgcolor: theme.palette.neutralGray000.main,
                border: `1px solid ${theme.palette.neutralGray10.main}`,
            }}
        />
    );
};

export type SenecRadioProps = RadioProps;

/**
 * The `SenecRadio` overwrites some styling of the MUI Radio component.
 * It accepts all properties of a MUI Radio.
 * @param SenecRadioProps
 * @constructor
 */
export const SenecRadio = ({ ...props }: SenecRadioProps) => {
    return <Radio disableRipple color="default" checkedIcon={<CheckedRadio />} icon={<UncheckedRadio />} {...props} />;
};
